if (!customElements.get('module-code')) {
  customElements.define('module-code', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('button');
      this.source = this.querySelector('code');
      this.status = this.querySelector('[role="status"]');
      if (window.Prism) window.Prism.highlightElement(this.source);
      this.button.hidden = false;
      this.button.addEventListener('click', async () => {
        clearTimeout(this.resetTimer);
        try {
          await navigator.clipboard.writeText(this.source.textContent);
          this.button.textContent = 'Copied!';
          this.status.textContent = 'Code copied to clipboard.';
        } catch {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(this.source);
          selection.removeAllRanges();
          selection.addRange(range);
          this.source.parentElement.focus();
          this.button.textContent = 'Code selected';
          this.status.textContent = 'Copy was unavailable. Code selected; use your device’s copy command.';
        }
        this.resetTimer = setTimeout(() => { this.button.textContent = 'Copy code'; }, 2500);
      });
    }

    disconnectedCallback() {
      clearTimeout(this.resetTimer);
    }
  });
}

if (!customElements.get('module-pcb-gallery')) {
  customElements.define('module-pcb-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal) return;
      const images = this.querySelector('.module-technical__enlarged');
      const links = this.querySelectorAll('a[data-pcb-caption]');
      links.forEach((link) => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', this.dialog.id);
        link.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!images.childElementCount) {
            links.forEach((source) => {
              const figure = document.createElement('figure');
              const image = document.createElement('img');
              image.src = source.href;
              image.alt = source.querySelector('img').alt;
              const caption = document.createElement('figcaption');
              caption.textContent = source.dataset.pcbCaption;
              figure.append(image, caption);
              images.append(figure);
            });
          }
          this.previousOverflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
        });
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow;
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          this.dialog.close();
        }
      });
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

if (!customElements.get('module-model-viewer')) {
  customElements.define('module-model-viewer', class extends HTMLElement {
    connectedCallback() {
      this.viewer = this.querySelector('model-viewer');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.updateCamera = () => {
        if (this.dataset.autoFit === 'true') return;
        const distance = Number(this.mobile.matches ? this.dataset.mobileDistance : this.dataset.desktopDistance);
        this.viewer.minCameraOrbit = 'auto auto 1m';
        this.viewer.maxCameraOrbit = `auto auto ${Math.max(distance * 3, 100)}m`;
        this.viewer.cameraOrbit = `0deg 75deg ${distance}m`;
      };
      this.updateMotion = () => this.viewer.toggleAttribute('auto-rotate', this.dataset.autoRotate === 'true' && !this.motion.matches);
      this.mobile.addEventListener('change', this.updateCamera);
      this.motion.addEventListener('change', this.updateMotion);
      this.viewer.addEventListener('load', this.updateCamera);
      this.updateMotion();
      customElements.whenDefined('model-viewer').then(() => { if (this.isConnected) this.updateCamera(); });
    }

    disconnectedCallback() {
      this.mobile.removeEventListener('change', this.updateCamera);
      this.motion.removeEventListener('change', this.updateMotion);
      this.viewer.removeEventListener('load', this.updateCamera);
    }
  });
}
